import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { DefaultPerPageValue, PerPage } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import Search from "../../Components/casp/common/Search";
import { ProjectStatuses } from "../../constants/Status";
import DownloadIcon from '@mui/icons-material/Download';
import { documentList, getDownloadableLink } from "../../api/casp/document";
import { getAllProject } from "../../api/casp/project";
import { toast } from "react-toastify";

const DocumentList = (props) => {

  const [documents, setDocuments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [project, setProject] = useState();
  const [filterData, setFilterData] = useState()
  const [projectList, setProjectList] = useState([]);
  const [searchedTerm, setSearchedTerm] = useState(null)
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleLinkDownload = async (documentId) => {
    try {
      const result = await getDownloadableLink(documentId);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
        window.open(result.data.data, '_blank');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const columnData = [
    {
      field: "index",
      headerName: "#",
      width: 85,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
        </div>
      ),
    },
    {
      field: "projectUniqueId",
      headerName: props.t("Startup ID"),
      width: 200,
      filterable: false,
      sortable: false,
    },
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      width: 300,
      filterable: false,
      sortable: false,
    },
    {
      field: "documentName",
      headerName: props.t("Document Name"),
      width: 300,
      filterable: false,
      sortable: false,
    },
    {
      field: 'action',
      headerName: props.t('Actions'),
      sortable: false,
      width: 100,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <div
          className="proSubmissionActions newActionIcons"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
        >
          <div
            onClick={() => handleLinkDownload(params.row.id)}
            style={{ cursor: 'pointer' }}
          >
            <DownloadIcon />
          </div>
        </div>
      ),
    },

  ];

  useEffect(() => {
    fetchDocumentList({ page: page + 1, perPage: rowsPerPage, ...filterData });
    fetchProjectList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerData])

  const fetchDocumentList = async (queryParams) => {
    try {
      setIsLoading(true);
      let params = {
        ...queryParams,
        ...(search && { search }),
        projectStatus: ProjectStatuses.ONGOING,
        perPage: rowsPerPage,
        page: page + 1,
      }
      const res = (await documentList(params)).data.data;
      let level = (params?.page + 1 - 1) * params?.perPage;
      const resultData = res.data.map((res) => {
        return {
          id: res.id,
          indexNo: ++level,
          projectUniqueId: res.project.uniqueProjectId,
          link: getDownloadableLink(res.id),
          projectName: res.project.name,
          documentName: res.name
        };
      });
      setDocuments(resultData);
      setRowCount(res.meta.total);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const fetchProjectList = async () => {
    try {
      setIsLoading(true);
      let params = {
        filterFields: ["status"],
        filterInputs: [ProjectStatuses.ONGOING]
      }
      const res = (await getAllProject(params)).data.data;
      const resultData = res.data.map((res) => {
        return res.name
      });
      setProjectList(resultData)
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  // const handleProjectChange = async (_, item) => {
  //   if (item == null) {
  //     setFilterData()
  //   } else {
  //     setFilterData({ filterFields: ["project"], filterInputs: [item] })
  //   }
  //   setTriggerData(+new Date())
  // }

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    // if (params?.page) {
    //   setPage(params.page);
    // }
    await fetchDocumentList(params);
  };

  const getRowId = (row) => row.id;

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });
              if (!newFaviconElems.length) {
                return;
              }
              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;
              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );
              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }
              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );
              const iconToShow = <ManageAccountsIcon />;
              //<i className={'ri-git-pull-request-line'}></i>
              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    iconToShow
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{props.t("Document List")}</title>
        </Helmet>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={props.t("Startup Files")} />
            </div>
            <div className="d-flex justify-content-end ongoingSearchField">
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Startup Name")}
                  searchEnabled={false}
                  disableClearable={!project}
                  listCall={getAllProject}
                  defaultValue={project}
                  size="small"
                  sx={{ width: "200px" }}
                  emitItem={(newValue) => {
                    setProject(newValue);
                    if (newValue) {
                      setFilterData({
                        filterFields: ["project"],
                        filterInputs: [newValue.name]
                      })
                    } else {
                      setFilterData({
                        filterFields: [],
                        filterInputs: []
                      })
                    }
                    setTriggerData(+new Date());
                  }}
                  apiParams={searchedTerm && searchedTerm !== "undefined" ? {
                    filterFields: ["name", "status"],
                    filterInputs: [searchedTerm, ProjectStatuses.ONGOING]
                  } : {
                    filterFields: ["status"],
                    filterInputs: [ProjectStatuses.ONGOING]
                  }}
                  handleInputChange={(data) => setSearchedTerm(data)}
                />
              </div>
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    ...(props?.status ? {
                      filterFields: ["status"],
                      filterInputs: [props.status]
                    } : {}),
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>
            {documents.length > 0 && (
              <DataGrid
                key={refreshKey}
                rows={documents}
                columns={columnData}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
                localeText={{
                  noRowsLabel: props.t("No rows"),
                  MuiTablePagination: {
                    labelRowsPerPage: props.t("Rows per page:"),
                  },
                }}
              // onRowSelectionModelChange={(e) => setIsSendMsg({ data: e, status: false })}
              // checkboxSelection={loggedInUser?.role?.name === Role.EPMO_OFFICER}
              />
            )}
            {documents.length === 0 && isLoading && <Loader />}
            {documents.length === 0 && !isLoading && (
              <NodataFound text={props.t("No document to show")} icon={userImage} />
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}
export default withTranslation()(DocumentList)
